import { Caption } from '@xo-union/tk-ui-typography';
import React from 'react';

import styles from './headline.scss';
import { Item, ItemProps } from './Item';

interface Props extends Omit<ItemProps, 'children'> {
  header?: string;
  text: string;
}

export const ParagraphItem: React.FC<Props> = ({ onClick, header = 'Text Block', text, ...rest }) => (
  <Item onClick={onClick} {...rest}>
    <div className={styles.container}>
      <Caption className={styles.title}>{header}</Caption>
      <Caption className={styles.paragraph}>{text}</Caption>
    </div>
  </Item>
);
